export const ERROR_MESSAGE: Record<string, string> = {
  fe_custom_turnstile_uncheck_error: "캡챠 체크박스를 체크해주세요.",
  fe_custom_turnstile_token_error: "오류가 발생했습니다. 새로고침 후 다시 시도해 주세요.",
  fe_custom_old_ie_error:
    "IE 10 이하 버전의 인터넷 익스플로러에서는 Apple 로그인이 정상 작동하지 않을 수 있습니다. \n로그인이 원활하지 않을 경우 인터넷 익스플로러를 최신 버전으로 업데이트하여주세요.",
  need_captcha: "고객님의 정보보호를 위해 넥슨ID/비밀번호와 자동입력 방지문자를 함께 입력해주세요.",
  invalid_captcha_token: "로그인 중 오류가 발생했습니다. \n새로고침 후 다시 시도해주세요.",
  mismatch_captcha_id: "로그인 중 오류가 발생했습니다. \n새로고침 후 다시 시도해주세요.",
  blocked_by_nass: "넥슨ID 보호를 위해 일시적으로 로그인이 제한되었습니다. \n잠시 후 다시 시도해주세요.",
  blocked_by_admin: "관리자에 의해 서비스 이용이 제한되었습니다.\n넥슨 고객센터로 문의해주세요.",
  not_exists_account: "넥슨ID 혹은 비밀번호를 잘못 입력하셨거나 등록되지 않은 넥슨ID 입니다.",
  invalid_id: "넥슨ID 혹은 비밀번호를 잘못 입력하셨거나 등록되지 않은 넥슨ID 입니다.",
  invalid_password: "넥슨ID 혹은 비밀번호를 잘못 입력하셨거나 등록되지 않은 넥슨ID 입니다.",
  blocked_international_signin:
    "해외 로그인 차단 기능이 실행되었습니다.\n넥슨닷컴에서 로그인하시면 본인확인을 통해 안전하게 로그인 할 수 있습니다.",
  switched_to_email_id: "이메일ID로 전환하신 고객님입니다.\n이메일 형태의 넥슨ID를 입력해주세요.",
  protected_by_nass:
    "고객님의 넥슨ID는 현재 보호모드가 적용 중입니다.\n넥슨닷컴에서 로그인하시면 보호모드 해제 후 서비스를 이용할 수 있습니다.",
  withdrawal_grace_period: "고객님의 넥슨ID는 회원탈퇴 처리 중입니다.\n넥슨닷컴에서 로그인하시면 회원탈퇴 취소가 가능합니다.",
  request_parent_agreement:
    "고객님은 회원가입 대기 상태입니다.\n넥슨닷컴에서 로그인하시면 보호자동의 진행 후 회원가입을 완료할 수 있습니다.",
  external_system_inspection: "서비스 점검 중입니다. \n 잠시 후 다시 시도해주세요.",
  unstable_network:
    "사용자 네트워크 연결 상태가 불안정하거나,\n부정적인 접근 시도가 감지된 환경일수 있습니다. \n넥슨 고객센터로 문의해주세요.",
  hasDeletedOldSession: "먼저 로그인 되어 있는 다른 브라우저의 넥슨ID를 로그아웃 후 로그인합니다.",
  mismatch_client_ip:
    "로그인한 IP주소와 현재 IP주소가 일치하지 않아 서비스를 이용할 수 없습니다. 넥슨ID 보호를 위해 다시 로그인 해주세요. \n(IP 변경이 일어날 수 있는 서비스나 기능을 사용하는 경우, 해제 후 이용해주세요.)",
  invalid_otp: "일회용 로그인 번호가 일치하지 않습니다. \n정확한 번호를 확인 후 다시 입력해주세요.",
  blocked_signin_with_otp:
    "잘못된 요청으로 24시간 동안 이용이 제한됩니다. \n서비스 이용을 원하신다면 넥슨ID와 비밀번호로 로그인해주시기 바랍니다.",
  unauthorized: "시스템 오류로 로그인에 실패하였습니다.\n잠시 후 다시 로그인을 시도해주세요.",
  internal_server_error: "시스템 오류로 로그인에 실패하였습니다.\n잠시 후 다시 로그인을 시도해주세요.",
  db_error: "시스템 오류로 로그인에 실패하였습니다.\n잠시 후 다시 로그인을 시도해주세요.",
  already_exists_account: "이미 보호자 동의가 완료되었습니다.",
  not_exists_request_parent_agreement: "보호자 동의 유효기간이 종료되었습니다.",
};
